<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints, useWindowScroll } from '@vueuse/core'

defineProps<{
  topOffset?: number
  title: string
  text?: StoryBlokRichText
  image?: StoryBlokImage
  button: StoryBlokComponent
}>()

const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('sm')
const isTablet = breakpoints.smaller('md')
const { y: wy } = useWindowScroll()
</script>

<template>
  <transition :name="isMobile ? 'show-y' : 'show-y-top'">
    <div
      v-if="topOffset ? wy > topOffset : isMobile ? true : wy > 300"
      id="floating-bar"
      class="fixed z-30 bg-white shadow-hover w-screen mx-auto py-8px sm:px-0 <sm:text-center"
      :class="isMobile ? 'position-bottom' : 'position-top'"
    >
      <div :class="!isMobile && 'content-container px-3'">
        <div class="flex flex-col justify-center overflow-hidden sm:flex-row sm:justify-start items-center sm:max-h-80px">
          <div v-if="!isTablet && image?.filename" class="flex pr-5 mr-5 border-r border-gray-light flex h-40px items-center">
            <StoryblokImage :src="image" width="180" />
          </div>
          <div class="flex-auto">
            <div class="text-xl font-bold">
              {{ title }}
            </div>
            <StoryblokRichText v-if="useHasContent(text) && !isMobile" :document="text" class="leading-28px" />
          </div>
          <div class="flex items-center pt-2 sm:pt-0">
            <StoryblokButton v-bind="button[0]" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
.show-y-enter-from,
.show-y-leave-to {
  transform: translateY(100px);
}

.show-y-enter-active,
.show-y-leave-active {
  transition: all 0.3s ease-in;
}

// Top animation
.show-y-top-enter-from,
.show-y-top-leave-to {
  transform: translateY(-100px);
}

.show-y-top-enter-active,
.show-y-top-leave-active {
  transition: all 0.15s ease-in;
}

.position-top {
  @apply top-0 left-0
}

.position-bottom {
  @apply bottom-0
}
</style>
